import Wordcloud from 'wordcloud';
import React, { Component } from 'react';
import IsLoadingBar from '../isLoading';

let hoverWord = null;

export default class WordcloudSimple extends Component {
    constructor(props){
        super(props);

        this.state = {
            isLoading: true
        };

    }

  componentDidMount() {
      let self = this;
      const list = [];
      let data = this.props.data;
      for(let i = 0; i < data.length; i++){          
        let item = [data[i].text,(data[i].score * 1.3),data[i].value];
        list.push(item);
    }    

    Wordcloud(
      this.refs["my-canvas"],
      {list: list,
        color: function() {
            return (["#3067DB","#4285f4", "#689df6", "#1e51bf", "#60a1b9","#393839","#006ECE","#01A5FF"])[Math.floor(Math.random() * 8)];
          },
        rotationSteps: 2,
        backgroundColor: 'transparent',
        rotateRatio: 0,
        shrinkToFit: true,
        click: function(item) {
            self.props.relatedWords(item[0]);
        },
        hover: function(item,dimensions,event) {
            if(item !== undefined){
                if(hoverWord !== item[0]){
                    self.setState({
                        word: item[0],
                        value: item[2]
                    });
                }
            }
        }
    }
    );

    this.setState({
        isLoading: false
    });
  }

  render() {
    return (        
    <div id="wordcloud_container" style={{width : '45vw', height: '100%'}}>
        {this.state.isLoading && (
            <IsLoadingBar />
        )}
        <h5 style={{ textTransform: "capitalize" }}><strong style={this.state.word ? {opacity : 1} : {opacity: 0}}>{this.state.word} : {this.state.value}</strong></h5>
        <div className="m-auto">
            <canvas ref="my-canvas" style={this.state.isLoading ? { opacity : 0} : { opacity : 1 }} id="canvas" width={window.screen.width / 2.5} height={(window.screen.height / 2.5) + 150} />
        </div>        
    </div>    
    );
  }
}